<box class="product-request-type">
    <header>
        <box class="header-title">
            <span class="title">Request Type</span>
            <span class="caption">Please select one request type</span>
        </box>
        <fpx-button className="close" btnType="button" label="close" (onClick)="closeAlert()"></fpx-button>
    </header>

    <box class="actions-group">
        <fpx-button className="secondary" btnType="button" label="New Card" (onClick)="closeAlert('newCard')"></fpx-button>
        <fpx-button className="secondary" btnType="button" label="Supplementary Card" (onClick)="closeAlert('supplementaryCard')"></fpx-button>
    </box>

</box>